module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/Ayodhya-GT-Funnel-dWeb.d2a48300.jpg";